export default __webpack_public_path__ + "static/media/brigitte.aa2a859f.webp";